import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Drawer, Select} from 'antd';
import { useRecoilState } from 'recoil';
import { classesAtom } from '_state';
import { useClassWrapper, useFetchWrapper } from '_helpers';
import { useCapabilities } from '_helpers/capabilities';
import { useHistory, useLocation } from 'react-router-dom';
import { classSlug } from '_helpers/normalize';
// import { useClassActions } from '_actions';

export { ClassPicker };

function ClassPicker(props) {
    const classWrapper = useClassWrapper();
    const history = useHistory();
    const location = useLocation();
    const [classes, setClasses] = useRecoilState(classesAtom);
    const [visible, setVisible] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    // Lớp chính thức and lớp học thử are separate worlds — one is shown at a time, never mixed.
    const [mode, setMode] = useState('normal');
    const [query, setQuery] = useState('');

    const showModal = () => {
      setVisible(true);
    };

    const handleOk = (values) => {
      // console.log("Sending.");
      setConfirmLoading(true);
      // The mode you're in decides what you create — no toggle inside the form to contradict it.
      classWrapper.createClass(values.class_name, {
        is_trial: mode === 'trial',
        class_teacher_id: values.class_teacher_id,
      });
      setVisible(false);
      setConfirmLoading(false);
      // console.log(classes);
    };

    var drawerVisible = props.drawerVisible;
    var setDrawerVisible = props.setDrawerVisible;
    var onDrawerClose = props.onDrawerClose;
    var input = classWrapper.classes;
  
    // console.log(input);

    const moduleForCurrentRoute = () => {
        const parts = (location.pathname || '').split('/').filter(Boolean);
        const mod = parts[1] || 'dashboard';
        return ['attendance', 'dashboard', 'studentinfo', 'studentscore', 'home-assignments', 'tuition'].includes(mod)
            ? mod
            : 'dashboard';
    };

    const choose = (cls) => {
        const isCurrent = classWrapper.curClass && classWrapper.curClass.class_id === cls.class_id;
        if (!isCurrent) {
            classWrapper.chooseClass(cls);
            const mod = moduleForCurrentRoute();
            history.push(`/${classSlug(cls)}/${mod === 'dashboard' ? 'dashboard' : mod}`);
        }
        onDrawerClose();
    };

    const matchText = (cls) => [
        cls.class_name,
        cls.class_id,
        classSlug(cls).slice(-6),
        cls.class_teacher?.name,
        cls.class_teacher?.student_id,
        cls.class_teacher?.role,
        ...(cls.assigned_teachers || []).flatMap(t => [t.name, t.student_id, t.role]),
    ].filter(Boolean).join(' ').toLowerCase();

    const renderCard = (cls) => {
        const isCurrent = classWrapper.curClass && classWrapper.curClass.class_id === cls.class_id;
        return (
            <div key={cls.class_id} className="cp-cell">
                <button
                    type="button"
                    aria-current={isCurrent ? 'page' : undefined}
                    className={(cls.archived ? 'cp-card cp-card-archived' : 'cp-card') + (isCurrent ? ' cp-card-current' : '')}
                    onClick={() => choose(cls)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(cls); }
                    }}
                >
                    <div className="cp-card-title">{cls.class_name}</div>
                    <div className="cp-card-meta">
                        {cls.class_id}
                        {cls.class_teacher?.name ? ` · ${cls.class_teacher.name}` : ''}
                    </div>
                    {isCurrent && <span className="tag tag-ok cp-card-tag">Đang chọn</span>}
                    {cls.archived && <span className="tag t-neutral cp-card-tag">Chỉ đọc</span>}
                </button>
            </div>
        );
    };

    // Each mode carries its own archive, so an archived trial class stays inside học thử instead of
    // surfacing among the real classes.
    const inMode = (c) => (mode === 'trial' ? !!c.is_trial : !c.is_trial);
    const term = query.trim().toLowerCase();
    const filtered = input.filter(c => inMode(c) && (!term || matchText(c).includes(term)));
    const activeCards   = filtered.filter(c => !c.archived).map(renderCard);
    const archivedCards = filtered.filter(c => c.archived).map(renderCard);

    const normalCount = input.filter(c => !c.archived && !c.is_trial).length;
    const trialCount  = input.filter(c => !c.archived && c.is_trial).length;

    const addCard = (
        <div key='add-class' className="cp-cell" onClick={() => { showModal(); }}>
            <div className="cp-card cp-card-add">
                <div className="cp-card-title">{mode === 'trial' ? 'Thêm lớp học thử' : 'Thêm lớp học'}</div>
                <p className="cp-card-hint">Nhấn vào để thêm lớp mới</p>
            </div>
        </div>
    );

    const header = (
        <div className="cp-head">
            <span style={{ color: 'var(--ink-2)' }}>Chọn một lớp...</span>
            <div className="seg">
                <button className={mode === 'normal' ? 'on' : ''} onClick={() => setMode('normal')}>
                    Chính thức <span className="seg-n">{normalCount}</span>
                </button>
                <button className={mode === 'trial' ? 'on' : ''} onClick={() => setMode('trial')}>
                    Học thử <span className="seg-n">{trialCount}</span>
                </button>
            </div>
            <Input.Search
                className="cp-search"
                allowClear
                value={query}
                onChange={e => setQuery(e.target.value)}
                placeholder="Tìm lớp, giáo viên, mã lớp..."
            />
        </div>
    );

    return (
        <Drawer title={header} placement="right" onClose={onDrawerClose} visible={drawerVisible} width={window.innerWidth <= 768 ? '100vw' : 640}>
            <CollectionCreateForm
                visible={visible}
                isTrial={mode === 'trial'}
                onCreate={handleOk}
                onCancel={() => {
                    setVisible(false);
                }}
            />
            <div className="cp-grid">
                {activeCards}
                {addCard}
            </div>
            {archivedCards.length > 0 &&
                <>
                    <h2 className="cp-section-title" style={{ color: 'var(--ink-2)' }}>Đã lưu trữ</h2>
                    <div className="cp-grid">{archivedCards}</div>
                </>}
        </Drawer>
    )
}

const CollectionCreateForm = ({ visible, isTrial, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    const fetchWrapper = useFetchWrapper();
    const { canManageUsers } = useCapabilities();
    const [teachers, setTeachers] = useState([]);

    // A trial class's owner collects its teaching hours in the KPI table, and the creator is the owner
    // by default — so a manager creating one on a teacher's behalf must name them, or the hours land
    // on the manager. Teachers creating their own class are already the owner; no picker needed.
    useEffect(() => {
        if (!visible || !canManageUsers) return;
        (async () => {
            try {
                const res = await fetchWrapper.get('/api/manager/teachers', null, null);
                const json = await res.json();
                if (json.status === 'Success') setTeachers(json.message || []);
            } catch { /* picker just stays empty — creator remains the owner */ }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, canManageUsers]);

    return (
      <Modal
        animation={false}
        visible={visible}
        title={isTrial ? 'Tạo lớp học thử mới' : 'Tạo lớp học mới'}
        okText="Tạo"
        cancelText="Hủy"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form
          animation={false}
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{
            modifier: 'public',
          }}
        >
          <Form.Item
            name="class_name"
            label="Tên lớp:"
            rules={[
              {
                required: true,
                message: 'Please input the title of collection!',
              },
            ]}
            >
            <Input />
          </Form.Item>
          {isTrial && canManageUsers &&
            <Form.Item
              name="class_teacher_id"
              label="Giáo viên dạy"
              rules={[{ required: true, message: 'Chọn giáo viên để tính giờ dạy' }]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                placeholder="Chọn giáo viên"
              >
                {teachers.map(t => (
                  <Select.Option key={t.student_id} value={t.student_id}>
                    {t.name} ({t.student_id})
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>}
        </Form>
      </Modal>
    );
};
